const CheckUserLogin = (): void => {
    const element = document.querySelector('[data-refresh="True"]');

    if (!element) {
        return;
    }

    const pingUrl = element.getAttribute('data-pingUrl');

    if (!pingUrl) {
        document.querySelectorAll('.user-status').forEach(el => {
            el.classList.remove('signed-in');
        });
        return;
    }

    fetch(pingUrl, { credentials: 'include' })
        .then(response => {
            return response.json();
        })
        .then(data => {
            if (data.isSuccess && data.data.isLoggedIn) {
                document.querySelectorAll('.user-status').forEach(el => {
                    el.classList.add('signed-in');
                });
            } else {
                document.querySelectorAll('.user-status').forEach(el => {
                    el.classList.remove('signed-in');
                });
            }
        })
        .catch(() => {
            document.querySelectorAll('.user-status').forEach(el => {
                el.classList.remove('signed-in');
            });
        });
};

export default CheckUserLogin;
